module.exports = __webpack_public_path__ + "img/2.4872f943.jpg";